.pillContent {
  display: flex;
  justify-content: space-between;

  .iconContainer {
    margin: 0 0.5em;
    transform: scale(0.9);
  }
}
